import { Component, OnInit } from '@angular/core';
import { AdminApiService, AdminProduct } from '../../../core/services/admin-api.service';

@Component({
    selector: 'app-admin-products',
    templateUrl: './admin-products.component.html'
})
export class AdminProductsComponent implements OnInit {

    products: AdminProduct[] = [];

    model: any = {
        id: 0,
        name: '',
        category: '',
        description: '',
        sort: 0,
        status: true
    };

    selectedFile: File | null = null;

    loading = false;
    saving = false;
    errorMessage = '';
    successMessage = '';

    constructor(public adminApi: AdminApiService) { }

    ngOnInit(): void {
        this.getProducts();
    }

    getProducts(): void {
        this.loading = true;
        this.errorMessage = '';

        this.adminApi.getProducts().subscribe(
            (data: AdminProduct[]) => {
                this.products = data || [];
                this.loading = false;
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Products could not be loaded.';
                this.loading = false;
            }
        );
    }

    newProduct(): void {
        this.model = {
            id: 0,
            name: '',
            category: '',
            description: '',
            sort: 0,
            status: true
        };

        this.selectedFile = null;
        this.successMessage = '';
        this.errorMessage = '';
    }

    editProduct(item: AdminProduct): void {
        this.model = {
            id: item.id,
            name: item.name,
            category: item.category,
            description: item.description,
            sort: item.sort,
            status: item.status
        };

        this.selectedFile = null;
        this.successMessage = '';
        this.errorMessage = '';
    }

    onFileChange(event: Event): void {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files.length > 0) {
            this.selectedFile = input.files[0];
        }
    }

    saveProduct(): void {
        this.successMessage = '';
        this.errorMessage = '';

        if (!this.model.name || !this.model.category) {
            this.errorMessage = 'Product name and category are required.';
            return;
        }

        const formData = new FormData();

        formData.append('Id', this.model.id.toString());
        formData.append('Name', this.model.name || '');
        formData.append('Category', this.model.category || '');
        formData.append('Description', this.model.description || '');
        formData.append('Sort', this.model.sort ? this.model.sort.toString() : '0');
        formData.append('Status', this.model.status ? 'true' : 'false');

        if (this.selectedFile) {
            formData.append('Image', this.selectedFile);
        }

        this.saving = true;

        this.adminApi.saveProduct(formData).subscribe(
            () => {
                this.saving = false;
                this.successMessage = 'Product saved successfully.';
                this.newProduct();
                this.getProducts();
            },
            (error) => {
                console.error(error);
                this.saving = false;
                this.errorMessage = 'Product could not be saved.';
            }
        );
    }

    deleteProduct(id: number): void {
        if (!confirm('Delete this product?')) {
            return;
        }

        this.adminApi.deleteProduct(id).subscribe(
            () => {
                this.getProducts();
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Product could not be deleted.';
            }
        );
    }

    onImageError(event: Event): void {
        const img = event.target as HTMLImageElement;
        img.src = 'assets/img/products/placeholder.png';
    }
}